// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2164":"c2c2fb66","3775":"c2c2fb66","4965":"3f16b435"}[chunkId] + ".chunk.css";
};